var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTabLikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7218 15.5198C15.1254 17.7936 12.4706 19.2904 12 19.5471C11.5294 19.2904 8.87459 17.7936 6.2782 15.5198C3.46823 13.0589 1.00028 9.92527 1 6.64341C1.00184 5.14725 1.597 3.7129 2.65495 2.65495C3.7129 1.597 5.14726 1.00184 6.64341 1C8.56344 1.00016 10.1948 1.82088 11.2003 3.16007L12 4.22513L12.7997 3.16007C13.8052 1.82088 15.4366 1.00016 17.3566 1C18.8527 1.00184 20.2871 1.597 21.3451 2.65495C22.4031 3.71303 22.9983 5.14762 23 6.64398C22.9994 9.92564 20.5316 13.0591 17.7218 15.5198Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabLikes);
export default __webpack_public_path__ + "static/media/icon-tab-likes.df571aa84c119759e102bdb7965bbbf4.svg";
export { ForwardRef as ReactComponent };